import * as React from 'react';
import { TButtonSize, TButtonTheme } from '@cian/ui-kit/button/types';

import { BuilderChatButtonContainer } from '../BuilderChatButton';

interface IMessageButtonContainerProps {
  asIcon?: boolean;
  buttonSize?: TButtonSize;
  buttonTheme?: TButtonTheme;
  withOnboarding?: boolean;
  placeType: string;
}

/**
 * Развилка для кнопок, открывающих разные виды чатов.
 */
export const MessageButtonContainer: React.FC<IMessageButtonContainerProps> = props => {
  return <BuilderChatButtonContainer {...props} />;
};
